import { ECardType, EOrderStatus } from '@enum';
import { TBusinessProfile, TIndividualProfile } from '@xeppt/xeppt-sdk/types/user';
import { TButtonVariant } from '@components/common/button';

export type TCardOrder = {
    status: EOrderStatus;
    type: ECardType;
};

export type TBusinessDetails = {
    company_name: string;
    trading_name: string;
    registration_number: string;
    category: string;
    size: string;
    website?: string;
};

export type TNotificationAction = {
    label: string;
    onClick: () => void;
    variant: TButtonVariant;
};

//--------------- GUARDS ---------------//

export const isBusinessUserTypeGuard = (
    user: TIndividualProfile | TBusinessProfile
): user is TBusinessProfile => {
    return 'business' in user;
};
